import React, { useLayoutEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';

import { getEventBySlug } from '../events-data';
import { Button } from '../../../Atoms';
import Banner from './Banner';

import EventInfoCards from './sections/EventInfoCards';
import AboutSection from './sections/AboutSection';
import ScheduleSection from './sections/ScheduleSection';
import MapSection from './sections/MapSection';
import TeamSection from './sections/TeamSection';
import GallerySection from './sections/GallerySectionSlider';
import FaqSection from './sections/FaqSection';

/**
 * EventDetail
 * -------------------------------------------------------
 * Full detail page for a single event, at /events/:slug.
 *
 * This file is now just composition — each piece of the page
 * (Banner, the 3-card info row, About, Schedule, Map, Team,
 * Gallery, FAQ) lives in its own file under ./sections/ (Banner
 * keeps its own top-level folder as before). Every section
 * component checks its own data and returns null when that
 * event has nothing for it — e.g. GallerySection returns null
 * when `gallery` is empty — so this file never needs an
 * if/hasX check of its own.
 *
 * Global Navbar/Footer are not imported here — same as
 * AcDevKitSkill/index.jsx, they're supplied by the page's
 * layout wrapper (ViewWithNavbar) already.
 *
 * Folder layout:
 *   EventDetail/
 *     index.jsx          <- this file
 *     Banner/
 *       index.js
 *       style.css
 *     sections/
 *       icons.jsx
 *       EventInfoCards.jsx
 *       AboutSection.jsx
 *       ScheduleSection.jsx
 *       MapSection.jsx
 *       TeamSection.jsx
 *       GallerySection.jsx
 *       FaqSection.jsx
 */
export default function EventDetail() {
  useLayoutEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, []);

  const { slug } = useParams();
  const navigate = useNavigate();
  const event = getEventBySlug(slug);

  if (!event) {
    return (
      <div className="containers-min mx-auto px-4 py-24 text-center">
        <h2 className="font-gilroy mb-4">Event not found</h2>
        <p className="font-poppins text-black/70 mb-6">
          We couldn&apos;t find the event you&apos;re looking for.
        </p>
        <Button title="Back to Home" onClick={() => navigate('/')} />
      </div>
    );
  }

  return (
    <>
      <Banner event={event} />

      <EventInfoCards event={event} />
      <AboutSection about={event.about} />
      <ScheduleSection schedule={event.schedule} />
      {/* <TeamSection team={event.team} isPast={event.isPast} /> */}
      <GallerySection gallery={event.gallery} name={event.name} />
      <MapSection venue={event.venue} mapUrl={event.mapUrl} />
      <FaqSection faq={event.faq} />

      {/* <div className="containers-min mx-auto px-4 pb-16 text-center">
        <Link to="/" className="font-poppins font-semibold text-[rgb(35,180,85)]">
          ← Back to Home
        </Link>
      </div> */}
    </>
  );
}
